//const baseURL = "/";
let API_URL = "";
let assetsURL = "";

const LOCAL_IP = "192.168.1.42";
const LOCAL_URL = "https://sbsbhinmal.test/api/index";
const LIVE_URL = "https://sbsadmin.story365.in/api/index";

var getLocation = function (href) {
  var l = document.createElement("a");
  l.href = href;
  return l;
};
var l = getLocation(window.location.href);
console.log(l.hostname);
if (l.hostname === "localhost") {
  API_URL = LOCAL_URL;
  assetsURL = "http://localhost:5000/uploads";
} else if (l.hostname === LOCAL_IP) {
    API_URL = LOCAL_URL;
    assetsURL = "http://localhost:5000/uploads";  
} else if(l.hostname === 'sbs-mobile-application.onrender.com') {
  API_URL = LIVE_URL;
  assetsURL = "https://sbsadmin.story365.in/uploads";
} else if(l.hostname === 'sbsapp.story365.in') {
  API_URL = LIVE_URL;
  assetsURL = "https://sbsadmin.story365.in/uploads";
} 

var RESPONSE_SUCCESS = 200;
var BAD_REQUEST = 400;
var UNAURISED_REQUEST = 401;
var FORBIDDEN_REQUEST = 403;
var REQUEST_NOT_FOUND = 404;

var LIMIT_VALUE = 20;
var VALID_STRING_PATTERN = /^[A-Za-z0-9]+$/i;
var VALID_EMAIL_PATTERN = /\S+@\S+\.\S+/;
var INPUT_TEXT_LIMIT = 150;
var TEXTAREA_LIMIT = 500;
var VALID_PHONE_PATTERN = /^(0|[1-9]\d*)(\.\d+)?$/;
var PHONE_LENGTH=10

var PASSWORD_MIN_LENGTH=6;
var PASSWORD_MAX_LENGTH=15;

var LOGOUT_MESSAGE = 'You are logout successfully.';

const PER_PAGE_LIST = [{'value':5,'label':5},{'value':10,'label':10},{'value':15,'label':15},{'value':20,'label':20},{'value':25,'label':25},{'value':30,'label':30},,{'value':50,'label':50},{'value':100,'label':100}];
const STATUS_ARR = [{ 'value' : 1, 'label' :  'Active'},{ 'value' : 2, 'label' :  'Inactive'}];


export {
  API_URL,
  assetsURL,
  RESPONSE_SUCCESS,
  BAD_REQUEST,
  UNAURISED_REQUEST,
  FORBIDDEN_REQUEST,
  REQUEST_NOT_FOUND,
  LOGOUT_MESSAGE,
  LIMIT_VALUE,
  VALID_STRING_PATTERN,
  VALID_EMAIL_PATTERN,
  INPUT_TEXT_LIMIT,
  TEXTAREA_LIMIT,
  PER_PAGE_LIST,
  STATUS_ARR,
  VALID_PHONE_PATTERN,
  PHONE_LENGTH,
  PASSWORD_MIN_LENGTH,
  PASSWORD_MAX_LENGTH

};